// extracted by mini-css-extract-plugin
module.exports = {"swiperBtnPrev":"styles_swiperBtnPrev__1xELF","swiperBtnNext":"styles_swiperBtnNext__21_0l"};